// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import type {RootState} from '../../index';
import type {Dispatch} from 'redux';
import {actions as ReferralActions} from '../duck';
import Referral from '../components/Referral';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    user: state.auth.user,
    referreds: state.referral.referreds,
    points: state.referral.availablePoints,
    referralError: state.referral.errorPoints,
    referredsError: state.referral.errorReferreds,
    isFetchingReferreds: state.referral.isFetchingReferreds,
    pagination: state.referral.pagination,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...ReferralActions,
      },
      dispatch
    )
)(Referral);
